import * as moment from "moment";
import * as React from "react";
import { connect } from "react-redux";
import Spinner from "react-spinkit";
import { Dispatch, bindActionCreators } from "redux";
import * as actionCreators from "../../action-creators";
import { Allocation } from "../../domain/sfp/allocation-domain";
import * as ChapterDomain from "../../domain/sfp/chapter-domain";
import * as LoanDomain from "../../domain/sfp/loan-domain";
import { Tax } from "../../domain/sfp/tax-domain";
import { Profile } from "../../domain/sfp/user-domain";
import * as Model from "../../model";
import { MappedActionsProps, ReducerState } from "../../reducer";
import { findAllLoans, findLoans } from "../../service/sfp/loans-service-2";
import PPIService from "../../service/sfp/ppi-service";
import {
    findCurrentValidatedScenario
} from "../../service/sfp/scenarii-service";
import BasePage, { Props as BaseProps } from "../base-page";
import Notification, { NotificationLevel } from "../notification";
import ProgressLoader from "../progress-loader";
import { ToolbarItem } from "../toolbar";
import * as Configurator from "./configurator";
import BudgetFormPart from "./form-parts/budget-form-part";
import DebtFormPart from "./form-parts/debt-form-part";
import DOBFormPart from "./form-parts/dob-from-part";
import GeneralitiesFormPart from "./form-parts/generalities-form-part";
import ObservationFormPart from "./form-parts/observation-form-part";
import PpiFormPart from "./form-parts/ppi-form-part";
import StandardFormPart from "./form-parts/standard-type-form";
import TableFormPart from "./form-parts/table-form-part";
import * as Generator from "./generator";
import "./styles.scss";


class ManagementReport extends BasePage<InjectedProps, State> {
    protected editingProfiles: Profile[] = [
        Profile.SuperAdmin,
        Profile.RegionAdmin,
        Profile.LocalAuthorityAdmin,
        Profile.LocalAuthorityConsultant,
    ];
    private form: HTMLFormElement;
    protected viewingProfiles: Profile[] = [];
    protected toolbar = this.getToolbarItems();

    constructor(props: Readonly<InjectedProps>) {
        super(props);
        this.state = {
            allocations: this.initAllocations(),
            expenseChapters: [],
            generatingDocument: false,
            loadingData: true,
            decomposedLoans: [],
            childDecomposedLoans: [],
            ppi: null,
            fetchedBudgetData: null,
            receiptsChapters: [],
            scenario: null,
            taxes: this.initTaxes(),
            loader: 0,
            afterLoad: true,
            loans: [],
            priorities: [],
            report: null,
            gabarit: "Personalized",
            progress: 0, // La progression initiale
            totalCalls: 0, // Nombre total d'appels
            ongoingCalls: 0, // Nombre d'appels en cours
            initialProgress: true, // Un flag pour savoir si la progre

        };
        this.loadData(this.props);
    }
    timer = null;

    componentDidMount() {
        this.props.actions.setPageTitle("Rapport de gestion");
        this.startInitialProgress();
    }

    startInitialProgress = () => {
        if (this.props.ongoingCalls > 0) {
            this.handleProgress(); // Démarre directement la gestion des paliers
        } else {
            // Incrémente la progression de 1% toutes les secondes jusqu'à 20%
            const initialProgress = setInterval(() => {
                if (this.state.progress < 20) {
                    this.setState(prevState => ({
                        progress: prevState.progress + 1
                    }));
                } else {
                    clearInterval(initialProgress); // Arrêter dès que la progression atteint 20
                    this.handleProgress(); // Une fois à 20, gérer les paliers
                }
            }, 1000); // Incrémentation toutes les secondes
        }
    };

    handleProgress = () => {
        const { totalCalls, ongoingCalls } = this.props;
        
        if (totalCalls === 0 || ongoingCalls === 0) return; // Si aucune donnée n'est disponible

        // Calculer la taille du palier (80% répartis sur totalCalls)
        const progressPerCall = (80 / totalCalls);

        // Passer directement à 20 et commencer l'incrémentation par palier
        const nextTargetProgress = Math.ceil(20 + (ongoingCalls * progressPerCall));
        const prevTargetProgress = Math.ceil(20 + (ongoingCalls * progressPerCall) - progressPerCall);

        // On met a jour la progression si on a déjà fini l'appel précedent
        if (this.state.progress < prevTargetProgress) {
            this.setState(() => ({
                progress: prevTargetProgress
            }));
        }
        
        // Incrémenter la progression si nécessaire
        if (this.state.progress < nextTargetProgress) {
            this.incrementProgress(nextTargetProgress);
        }
    };

    incrementProgress = (nextTargetProgress: number) => {        
        const { totalCalls } = this.props;
        const baseSpeed = 500;  // Vitesse de base pour 1 palier
        const speedFactor = totalCalls > 1 ? baseSpeed * totalCalls : baseSpeed; // Plus il y a de paliers, plus la vitesse est lente

        // Incrémenter la progression de 1% jusqu'à atteindre le prochain palier
        const progressInterval = setInterval(() => {
            if (this.state.progress < nextTargetProgress && this.state.progress < 100) {
                this.setState(prevState => ({
                    progress: prevState.progress + 1
                }));
            } else {
                clearInterval(progressInterval); // Arrêter dès qu'on atteint le palier ou 100%
            }
        }, speedFactor);
    };


    componentDidUpdate(prevProps, prevState) {
        // Si on reçoit totalCalls ou ongoingCalls, on commence à gérer la progression
        if (this.props.totalCalls !== prevProps.totalCalls || this.props.ongoingCalls !== prevProps.ongoingCalls) {
            this.handleProgress();
        }

        // Si les appels sont finis, mettre la progression à 100%
        if (this.props.allCallsFinished && this.state.progress < 100) {
            this.setState({ progress: 100 });
        }
    }

    handleChange = (report: any): any => {
        this.setState({ report })
    }

    changeGabarit = (gab: string): any => {
        this.setState({ gabarit: gab })
    }

    protected isLoading(): boolean {
        return super.isLoading();
    }

    protected renderPageContent() {
        const loading = this.isLoading() || this.state.loadingData;
        const services = this.props.currentLocalAuthorityServices;
        const disabled = this.props.loadingtableData;
        const { totalCalls, ongoingCalls, allCallsFinished } = this.props;        

        return <div>            
            {!allCallsFinished ? (
                <div className="section">
                    Chargement...
                    <ProgressLoader bgcolor="blue" completed={this.state.progress} />
                </div>
            ) : (
                <div>
                    {this.state.generatingDocument &&
                        <div className="generate-loader">
                            <Spinner fadeIn="none" name="wave" color="#3d3c3f" />
                            <span>Téléchargement du document...</span>
                        </div>}

                    <form
                        className="container is-fluid"
                        ref={(form) => (this.form = form)}
                        method="POST"
                        onSubmit={(e) => this.handleSubmit(e)}
                    >
                        {this.renderNotificationIfNeeded()}

                        <div className="columns content is-multiline">

                            {/* Type rapport */}
                            <div className="column is-full">
                                <StandardFormPart
                                    handleChange={e => this.handleChange(e)}
                                    changeGabarit={e => this.changeGabarit(e)} />
                            </div>


                            {/* Généralités */}
                            <div className="column is-half-desktop">
                                <GeneralitiesFormPart
                                    loading={loading}
                                    localAuthority={this.props.currentLocalAuthority}
                                    report={this.state.report}
                                />
                            </div>

                            {/* Personnalisation des tableaux */}
                            <div className="column is-half-desktop">
                                <TableFormPart />
                            </div>

                            {/* Constat rétrospective et prospectif */}
                            <div className="column is-full">
                                <ObservationFormPart
                                    allocations={this.state.allocations}
                                    expenseChapters={this.state.expenseChapters}
                                    loading={loading}
                                    receiptsChapters={this.state.receiptsChapters}
                                    taxes={this.state.taxes}
                                    report={this.state.report}
                                />
                            </div>

                            {/* Structuration de la dette */}
                            <div className="column is-full">
                                <DebtFormPart
                                    decomposedLoans={this.state.decomposedLoans}
                                    loading={loading}
                                    report={this.state.report}
                                // disabled={disabled}
                                />
                            </div>

                            {/* PPI */}
                            <div className="column is-full">
                                <PpiFormPart
                                    ppi={this.state.ppi}
                                    scenario={this.state.scenario}
                                    services={services}
                                />
                            </div>

                            {/*DOB*/}
                            <div className="column is-full">
                                <DOBFormPart
                                    report={this.state.report}
                                />
                            </div>

                            {/*Budget annexes*/}
                            {this.props.currentLocalAuthority &&
                                this.props.currentLocalAuthority.members.length > 0 &&
                                !this.props.loadingtableData && (
                                    <div className="column is-full">
                                        <BudgetFormPart
                                            scenario={this.state.scenario}
                                            localAuthority={this.props.currentLocalAuthority}
                                        />
                                    </div>
                                )}
                        </div>
                    </form>
                </div>
            )}
        </div>
    }

    // private handleWaitingData() {
    //     if (this.state.loader > 80) {
    //         this.setState({ loader: 30 });
    //     }
    //     clearTimeout(this.timer);
    //     this.timer = setTimeout(() => {
    //         this.setState({ loader: this.state.loader + 1 });
    //     }, 1000);
    // }

    private getToolbarItems(): ToolbarItem[] {
        return [
            {
                icon: "file-download",
                text: "Télécharger le rapport de gestion",
                onClick: (e) => {
                    this.form &&
                        this.form.dispatchEvent(new Event("submit", { cancelable: true }))
                },
            },
            {
                icon: "undo",
                text: "Rétablir les valeurs par défaut",
                onClick: () => this.resetForm()
            },
        ];
    }

    private resetForm() {
        this.form && this.form.reset()
        this.setState({ report: null })
    }    


    private handleSubmit(e: React.SyntheticEvent<Element>): void {
        
        e.preventDefault();
        const loanDecomposition = LoanDomain.getLoansWithDecomposition(this.state.loans);

        const form = e.target as HTMLFormElement;
        const formData = new FormData(form);
        const configuration = Configurator.configure(
            formData,
            this.state.expenseChapters,
            this.state.receiptsChapters,
            this.state.ppi ? this.state.ppi.investment_themes : []
        );

        const loan_Data = this.buildLoans(configuration, this.state.loans, this.state.ppi, this.props.currentLocalAuthority, this.state.scenario);
        const fetchedBudgetData = !this.props.loadingtableData
            ? this.props.fetchTableData
            : null;
        this.setState({ generatingDocument: true }, () => {
            Generator.generate(
                configuration,
                this.props.currentLocalAuthority,
                loanDecomposition,
                this.state.scenario,
                this.state.ppi,
                fetchedBudgetData,
                this.state.childDecomposedLoans,
                loan_Data,
                this.state.loans,
                this.state.gabarit
            ).then((pptx) => {
                pptx.save(`Rapport de gestion - ${this.props.currentLocalAuthority.name}`);
                setTimeout(() => {
                    this.setState({ generatingDocument: false });
                }, 3000);
            });
        });
    }

    private initAllocations(): Allocation[] {
        return [
            Allocation.LumpSum,
            Allocation.Equalization,
            Allocation.Participation,
            Allocation.OfCompensation,
            Allocation.Other,
        ];
    }

    private initTaxes(): Tax[] {
        return [
            Tax.PropertyTax,
            Tax.Attribution,
            Tax.EqualisationFund,
            Tax.AdditionnalTax,
            Tax.OtherTax,
        ];
    }
    private buildLoans(configuration, loans, ppi?: Model.Ppi, localAuthority?: Model.LocalAuthority, scenario?: Model.Scenario): Model.PpiYearLoan[] {
        const lds = LoanDomain.getLoansWithDecomposition(loans);
        let years = configuration.generalities.years;
        if (configuration.debt.enableProspective) {
            const currentYear = new Date().getFullYear();
            let lastYear: number | null = null;
            if (localAuthority && localAuthority.isDebtSimplified) {
                // Dette simplifiée : max de toutes les sources
                const ppiMaxYear = ppi && ppi.years && ppi.years.length > 0
                    ? Math.max(...ppi.years.map((y: any) => y.year))
                    : null;
                const simplifiedMaxYear = localAuthority.localAuthorityDebtSimplifiedYears && localAuthority.localAuthorityDebtSimplifiedYears.length > 0
                    ? Math.max(...localAuthority.localAuthorityDebtSimplifiedYears.map(y => y.year))
                    : null;
                // Intérêts : scénario (compte 66111) en surcharge, décomposition réelle en base
                const scenarioMaxYear = scenario && scenario.years && scenario.years.length > 0
                    ? Math.max(...(scenario.years as any[]).map(y => y.year))
                    : null;
                const loansMaxYear = lds.length > 0
                    ? (() => { const d = LoanDomain.findLastPaymentDate(lds.map((ld: any) => ld.decomposition)); return d ? d.getFullYear() : null; })()
                    : null;
                const candidates = [ppiMaxYear, simplifiedMaxYear, scenarioMaxYear, loansMaxYear].filter(y => y != null) as number[];
                lastYear = candidates.length > 0 ? Math.max(...candidates) : null;
            } else if (lds.length > 0) {
                // Dette normale : les années prospectives vont jusqu'à la dernière date de paiement
                const decompositions = lds.map((ld: any) => ld.decomposition);
                const lastPaymentDate = LoanDomain.findLastPaymentDate(decompositions);
                if (lastPaymentDate) lastYear = lastPaymentDate.getFullYear();
            }
            if (lastYear != null) {
                const prospectiveYears: number[] = [];
                for (let y = currentYear; y <= lastYear; y++) {
                    if (!years.includes(y)) prospectiveYears.push(y);
                }
                years = years.concat(prospectiveYears);
            }
        }

        let yearLoans: Model.PpiYearLoan[] = [],
            yearLoan: Model.PpiYearLoan;

        lds.forEach((ld) => {
            const decomposition = ld.decomposition;
            const loan = ld.loan;
            let decom = {
                interests: [],
                paymentAmounts: [],
                paymentDates: [],
                periodicRates: [],
                reimboursedCapitals: [],
                remainingCapitals: [],
            };
            decomposition.paymentDates.map((date, i) => {
                let payDate;
                if (decomposition.remainingCapitals[i] > 0) {
                    decom.interests.push(decomposition.interests[i]);
                    decom.paymentAmounts.push(decomposition.paymentAmounts[i]);
                    decom.paymentDates.push(date);
                    decom.periodicRates.push(decomposition.periodicRates[i]);
                    decom.reimboursedCapitals.push(decomposition.reimboursedCapitals[i]);
                    decom.remainingCapitals.push(decomposition.remainingCapitals[i]);
                }
            });
            years.forEach((year) => {
                yearLoan = yearLoans.find((yl) => yl.year == year);
                if (!yearLoan) {
                    yearLoan = {
                        year: year,
                        total: 0,
                        reimbourse: 0,
                        interests: 0,
                        remaining: 0,
                        reimbours: 0,
                    };
                    yearLoans.push(yearLoan);
                }
                if (parseInt(moment(ld.loan.contractedOn).format("YYYY")) == year) {
                    yearLoan.total += ld.loan.amount; //getAnnuity(ld.decomposition, year)
                }

                if (isNaN(yearLoan.reimbourse)) yearLoan.reimbourse = 0;
                yearLoan.reimbourse += LoanDomain.getYearReimboursedCapital(
                    decomposition,
                    year
                );
                if (isNaN(yearLoan.interests)) yearLoan.interests = 0;
                yearLoan.interests += LoanDomain.getYearInterest(decomposition, year);
                if (isNaN(yearLoan.remaining)) yearLoan.remaining = 0;
                yearLoan.remaining += LoanDomain.getYearRemainingCapital(
                    decomposition,
                    year
                );

                /* Shifted year calculation Remborsement emprunts row */
                if (isNaN(yearLoan.reimbours)) yearLoan.reimbours = 0;
                yearLoan.reimbours += LoanDomain.getYearReimboursedCapital(decom, year);
            });
        });

        return yearLoans;
    }
    private loadData(props: Readonly<InjectedProps>): void {
        if (props.loadingCurrentLocalAuthority) return;
        if (!props.currentLocalAuthority) return;
        if (this.state.loadingData || props.loadingtableData) {
            Promise.all([
                PPIService.findPPIByLAId(props.currentLocalAuthority.id),
                findCurrentValidatedScenario(props.currentLocalAuthority),
                findLoans(props.currentLocalAuthority),
                findAllLoans(props.currentLocalAuthority),
            ])
                .then(
                    async ([ppi, scenario, loans, allLoan]: [
                        Model.Ppi,
                        Model.Scenario,
                        any,
                        Model.Loan
                    ]) => {
                        let projects: Model.PpiInvestmentProject[] = [];

                        ppi.investment_themes.forEach((theme) => {
                            projects = projects.concat(theme.projects);
                        });

                        const childDecomposedLoans = [
                            allLoan[0].map((s) => LoanDomain.getLoansWithDecomposition(s)),
                        ];
                        childDecomposedLoans.push(allLoan[1]);
                        const decomposedLoans = LoanDomain.geteDcompositionWithLoans(loans);
                        const expenseChapters = ChapterDomain.getDistinctChapters(
                            props.currentLocalAuthority.observations,
                            props.currentLocalAuthority.accounts,
                            true,
                            false
                        ).sort(ChapterDomain.compareByNumber);

                        const receiptsChapters = ChapterDomain.getDistinctChapters(
                            props.currentLocalAuthority.observations,
                            props.currentLocalAuthority.accounts,
                            true,
                            true
                        ).sort(ChapterDomain.compareByNumber);
                        if (
                            this.props.currentLocalAuthority.members.length == 0 ||
                            !this.props.loadingtableData
                        ) {
                            this.setState({ loadingData: false });
                        } else if (this.props.loadingtableData) {
                            // this.handleWaitingData();
                        }
                        this.setState({
                            expenseChapters,
                            decomposedLoans,
                            ppi,
                            receiptsChapters,
                            scenario,
                            childDecomposedLoans,
                            loans,
                        });
                    }
                )
                .catch((reason) => {
                    props.actions.throwError(reason);
                    this.setState({
                        loadingData: false,
                    });
                });
        }
    }

    private renderNotificationIfNeeded(): React.ReactNode {
        if (this.state.scenario && this.state.ppi) return null;

        const baseMessage =
            "Les données prospectives ne peuvent être calculées car";
        const noPpiMessage = "aucun PPI n'a été créé";
        const noScenarioMessage = "aucun scénario n'a été validé";
        const neitherScenarioNorPpiMessage = `${noScenarioMessage} et ${noPpiMessage}`;
        const message =
            `${baseMessage} ` +
            (!this.state.ppi && !this.state.scenario
                ? neitherScenarioNorPpiMessage
                : !this.state.ppi
                    ? noPpiMessage
                    : noScenarioMessage) +
            " pour l'année en cours.";

        return (
            <div className="section">
                <Notification
                    level={NotificationLevel.Warning}
                    light
                    message={message}
                />
            </div>
        );
    }
}

function mapDispatchToProps(
    dispatch: Dispatch<ReducerState>
): MappedActionsProps {
    return { actions: bindActionCreators(actionCreators, dispatch) };
}

function mapStateToProps(state: ReducerState): ReducerState {
    return state;
}

export default connect(mapStateToProps, mapDispatchToProps)(ManagementReport);

export interface Props extends BaseProps { }

interface State {
    allocations: Allocation[];
    expenseChapters: Model.Chapter[];
    generatingDocument: boolean;
    loadingData: boolean;
    decomposedLoans: Model.LoanWithDecomposition[];
    childDecomposedLoans: any;
    ppi: Model.Ppi;
    receiptsChapters: Model.Chapter[];
    scenario: Model.Scenario;
    taxes: Tax[];
    fetchedBudgetData: any;
    loader: number;
    afterLoad: boolean;
    loans: any;
    priorities: number[];
    report: any;
    gabarit: string;
    progress: number,
    totalCalls: number,
    ongoingCalls: number,
    initialProgress: boolean
}

type InjectedProps = MappedActionsProps & Props & ReducerState;


// WEBPACK FOOTER //
// ./src/component/management-report/index.tsx